import React from 'react';

export default
<g id="icon/whiteboard/chart" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <rect id="Rectangle" fill="#FD9698" x="0" y="0" width="64" height="8"></rect>
    <rect id="Rectangle" fill="#FD9698" x="0" y="18" width="64" height="4"></rect>
    <rect id="Rectangle" fill="#FD9698" x="0" y="0" width="4" height="64"></rect>
    <rect id="Rectangle" fill="#FD9698" x="60" y="0" width="4" height="64"></rect>
    <rect id="Rectangle" fill="#FD9698" x="36" y="0" width="4" height="64"></rect>
    <rect id="Rectangle" fill="#FD9698" x="48" y="0" width="4" height="64"></rect>
    <rect id="Rectangle" fill="#FD9698" x="12" y="0" width="4" height="64"></rect>
    <rect id="Rectangle" fill="#FD9698" x="24" y="0" width="4" height="64"></rect>
    <rect id="Rectangle" fill="#FD9698" x="0" y="32" width="64" height="4"></rect>
    <rect id="Rectangle" fill="#FD9698" x="0" y="46" width="64" height="4"></rect>
    <rect id="Rectangle" fill="#FD9698" x="0" y="60" width="64" height="4"></rect>
</g>
